/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';
import type { WebAuthnAttestation } from './WebAuthnAttestation';
import {
    WebAuthnAttestationFromJSON,
    WebAuthnAttestationFromJSONTyped,
    WebAuthnAttestationToJSON,
} from './WebAuthnAttestation';
import type { WebAuthnAuthenticatorAttachment } from './WebAuthnAuthenticatorAttachment';
import {
    WebAuthnAuthenticatorAttachmentFromJSON,
    WebAuthnAuthenticatorAttachmentFromJSONTyped,
    WebAuthnAuthenticatorAttachmentToJSON,
} from './WebAuthnAuthenticatorAttachment';
import type { WebAuthnResidentKey } from './WebAuthnResidentKey';
import {
    WebAuthnResidentKeyFromJSON,
    WebAuthnResidentKeyFromJSONTyped,
    WebAuthnResidentKeyToJSON,
} from './WebAuthnResidentKey';
import type { WebAuthnUserVerification } from './WebAuthnUserVerification';
import {
    WebAuthnUserVerificationFromJSON,
    WebAuthnUserVerificationFromJSONTyped,
    WebAuthnUserVerificationToJSON,
} from './WebAuthnUserVerification';

/**
 * 
 * @export
 * @interface WebAuthnMethodOptions
 */
export interface WebAuthnMethodOptions {
    /**
     * 
     * @type {FactorMethod}
     * @memberof WebAuthnMethodOptions
     */
    method: FactorMethod;
    /**
     * 
     * @type {string}
     * @memberof WebAuthnMethodOptions
     */
    scope?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebAuthnMethodOptions
     */
    available_credential_ids?: Array<string>;
    /**
     * 
     * @type {WebAuthnAuthenticatorAttachment}
     * @memberof WebAuthnMethodOptions
     */
    attachment?: WebAuthnAuthenticatorAttachment;
    /**
     * 
     * @type {WebAuthnUserVerification}
     * @memberof WebAuthnMethodOptions
     */
    user_verification?: WebAuthnUserVerification;
    /**
     * 
     * @type {WebAuthnResidentKey}
     * @memberof WebAuthnMethodOptions
     */
    resident_key?: WebAuthnResidentKey;
    /**
     * 
     * @type {WebAuthnAttestation}
     * @memberof WebAuthnMethodOptions
     */
    attestation?: WebAuthnAttestation;
}

/**
 * Check if a given object implements the WebAuthnMethodOptions interface.
 */
export function instanceOfWebAuthnMethodOptions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "method" in value;

    return isInstance;
}

export function WebAuthnMethodOptionsFromJSON(json: any): WebAuthnMethodOptions {
    return WebAuthnMethodOptionsFromJSONTyped(json, false);
}

export function WebAuthnMethodOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebAuthnMethodOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'method': FactorMethodFromJSON(json['method']),
        'scope': !exists(json, 'scope') ? undefined : json['scope'],
        'available_credential_ids': !exists(json, 'available_credential_ids') ? undefined : json['available_credential_ids'],
        'attachment': !exists(json, 'attachment') ? undefined : WebAuthnAuthenticatorAttachmentFromJSON(json['attachment']),
        'user_verification': !exists(json, 'user_verification') ? undefined : WebAuthnUserVerificationFromJSON(json['user_verification']),
        'resident_key': !exists(json, 'resident_key') ? undefined : WebAuthnResidentKeyFromJSON(json['resident_key']),
        'attestation': !exists(json, 'attestation') ? undefined : WebAuthnAttestationFromJSON(json['attestation']),
    };
}

export function WebAuthnMethodOptionsToJSON(value?: WebAuthnMethodOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'method': FactorMethodToJSON(value.method),
        'scope': value.scope,
        'available_credential_ids': value.available_credential_ids,
        'attachment': WebAuthnAuthenticatorAttachmentToJSON(value.attachment),
        'user_verification': WebAuthnUserVerificationToJSON(value.user_verification),
        'resident_key': WebAuthnResidentKeyToJSON(value.resident_key),
        'attestation': WebAuthnAttestationToJSON(value.attestation),
    };
}

